import { Row, Col, Button } from 'reactstrap'
import moment from 'moment'

const TripDayRow = ({ date, trips, onClickDetails }) => {
    const totalEarnings = trips.reduce((sum, t) => sum + (t.incomeTotal || 0), 0).toFixed(2)
    const formattedDate = moment(date).format('MMM D, YYYY')
    const tripCount = trips.length

    return (
        <Row className="align-items-center border-bottom py-2 mx-0">
            <Col xs="4">
                <div className="fw-semibold">{formattedDate}</div>
            </Col>
            <Col xs="5" className="text-muted small">
                {tripCount} trip{tripCount > 1 ? 's' : ''} – ${totalEarnings}
            </Col>
            <Col xs="3" className="align-items-center d-flex justify-content-end">
                <Button size="sm" color="primary" onClick={onClickDetails}>
                    Details
                </Button>
            </Col>
        </Row>
    )
}

export default TripDayRow
